import { useTranslation } from 'react-i18next';
import { useBasePath } from '~/common/hooks/useBasePath';
import { CheckIcon } from 'lucide-react';
import { getLanguageValue, webshopConfig } from '~/config/webshopConfig';
import { cn } from '~/common/utils/styleUtil';
import { getLinkRel } from '~/common/utils/urlUtil';

const aghAnvantages = [
  'Flexibel in den Einkaufszeiten',
  'Überzeugende Frische zum Erleben',
  'Einmalig günstiger Warenkorb'
];

const bghAnvantages = [
  'Über 25’000 Artikel, heute bestellt & morgen geliefert',
  'Bestes Preis-Leistungs-Verhältnis',
  'Regionale Verankerung'
];

export function Registration({ className }: Readonly<{ className?: string }>) {
  const { t, i18n } = useTranslation();
  const { isBgh, lang } = useBasePath();

  const advantages = isBgh ? bghAnvantages : aghAnvantages;

  return (
    <div className={cn('bg-primary p-4 rounded', className)} data-testid="registration-prompt">
      <h2 className={'text-2xl font-normal pb-4 text-white '}>{t('Jetzt Kunde werden & profitieren!')}</h2>
      <ul className={'text-white '}>
        {advantages.map(advantage => (
          <li key={advantage} className={'flex gap-2 py-1'}>
            <div className={'flex items-start pt-1'}>
              <CheckIcon size={16} className={'min-w-[36px]'} />
            </div>
            <div>{t(advantage as any)}</div>
          </li>
        ))}
      </ul>
      <a
        className={'mt-4 block p-3 bg-white text-primary px- hover:bg-primary-light 4 text-center rounded'}
        data-testid={'registration-link'}
        href={getLanguageValue(lang ?? i18n.language, webshopConfig.registrationLink)}
        target="_blank"
        rel={getLinkRel(getLanguageValue(lang ?? i18n.language, webshopConfig.registrationLink))}
      >
        {t('Kunde werden')}
      </a>
    </div>
  );
}
